import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <XCircleIcon className="w-8 h-8" data-id="element-126" />,
    title: 'Pagas 3x más de lo necesario',
    description: 'Las marcas premium cobran hasta 300% más por el mismo ingrediente activo.'
  }, {
    icon: <AlertTriangleIcon className="w-8 h-8" data-id="element-127" />,
    title: 'Marketing engañoso',
    description: 'Fórmulas "revolucionarias" que son solo creatina con nombres complicados.'
  }, {
    icon: <XCircleIcon className="w-8 h-8" data-id="element-128" />,
    title: 'Información contradictoria',
    description: 'Cada influencer dice algo diferente. ¿A quién le crees?'
  }, {
    icon: <AlertTriangleIcon className="w-8 h-8" data-id="element-129" />,
    title: 'Compras lo que no funciona',
    description: 'Gastas dinero en tipos de creatina con cero evidencia científica.'
  }];
  return <section className="w-full bg-[#0E2238] py-20 px-4 sm:px-6 lg:px-8" data-id="element-130">
      <div className="max-w-7xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-132">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6" data-id="element-133">
            ¿Estás Cansado de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500" data-id="element-134">
              Tirar Tu Dinero
            </span>
            ?
          </h2>
          <p className="text-xl text-[#F2F4F8]/80 max-w-3xl mx-auto" data-id="element-135">
            La industria de suplementos te está engañando. Es hora de conocer la
            verdad.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-136">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#132A44] border border-red-500/20 rounded-xl p-6 hover:border-red-500/40 transition-colors" data-id="element-137">
              <div className="flex items-start gap-4" data-id="element-138">
                <div className="flex-shrink-0 text-red-400" data-id="element-139">{problem.icon}</div>
                <div data-id="element-140">
                  <h3 className="text-xl font-bold text-[#F2F4F8] mb-2" data-id="element-141">
                    {problem.title}
                  </h3>
                  <p className="text-[#F2F4F8]/70" data-id="element-142">{problem.description}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-143">
          <div className="bg-gradient-to-r from-[#2F6BFF]/20 to-[#7EC8FF]/20 border border-[#2F6BFF]/30 rounded-xl p-8 max-w-4xl mx-auto" data-id="element-144">
            <h3 className="text-2xl sm:text-3xl font-bold text-[#F2F4F8] mb-4" data-id="element-145">
              Pero No Tiene Que Ser Así...
            </h3>
            <p className="text-lg text-[#F2F4F8]/80" data-id="element-146">
              Imagina saber exactamente qué creatina comprar, cuánto pagar, y
              cómo usarla para obtener resultados máximos. Sin trucos. Sin
              marketing. Solo ciencia real.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}